module.exports = __webpack_public_path__ + "static/media/stroller.pictogram.d0099f99.svg";